var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isAdmin)?_c('Title',{attrs:{"showMinister":true,"showService":true}}):_vm._e(),_c('Breadcrumb',{attrs:{"links":_vm.breadCrumbData}}),_c('Carrusel'),_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }